import { fromAxiosNutsJson, webstore } from '@/api';

const cart = {
  async addToCart(data) {
    return webstore.post('/cart', data);
  },
  async copyCustomerCart(key, { onMessages, onRedirect }) {
    const data = new FormData();
    data.set('key', key);
    await fromAxiosNutsJson(webstore.post('/cart/customer-cart', data), {
      onMessages,
      onRedirect,
    });
  },
  async lookUpCustomerCart(key, { onMessages }) {
    const { cart: customerCart } = await fromAxiosNutsJson(
      webstore.get(`/cart/customer-cart?key=${key}`),
      {
        onMessages,
      },
    );
    return customerCart;
  },
};
export default cart;
